import {
  useCompositeStoreOptions,
  useCompositeStoreProps
} from "../__chunks/7KULBIZY.js";
import "../__chunks/RS7KBRGA.js";
import {
  useStore
} from "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/menu/menu-bar-store.ts
import * as Core from "@ariakit/core/menu/menu-bar-store";
function useMenuBarStoreOptions(props) {
  return useCompositeStoreOptions(props);
}
function useMenuBarStoreProps(store, props) {
  return useCompositeStoreProps(store, props);
}
function useMenuBarStore(props = {}) {
  const options = useMenuBarStoreOptions(props);
  const store = useStore(
    () => Core.createMenuBarStore(__spreadValues(__spreadValues({}, props), options))
  );
  return useMenuBarStoreProps(store, props);
}
export {
  useMenuBarStore,
  useMenuBarStoreOptions,
  useMenuBarStoreProps
};
